<template>
  <div>
    <!-- Header con selector de tarifario -->
    <div class="card-body">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="form-group">
            <label for="tarifario" class="font-weight-bold">
              <i class="fas fa-list mr-1"></i>Seleccionar Tarifario
            </label>
            <v-select
              v-model="tarifario"
              label="nombre_completo"
              placeholder="Seleccione un tarifario para asignar..."
              :options="listasForms.tarifarios"
              @input="selectTarifario()"
              :class="[
                $store.getters.getDarkMode ? 'dark-vselect' : '',
                $v.form.tarifario_id.$invalid ? 'is-invalid' : 'is-valid',
                'form-control p-0',
              ]"
            />
          </div>
        </div>
        <div class="col-md-2 mt-3 pt-3">
          <button
            type="button"
            class="btn bg-info border-info btn-sm"
            v-if="!$v.form.$invalid"
            @click="saveTarifario()"
          >
            <i class="fas fa-plus mr-1"></i>
            Asignar Tarifario
          </button>
        </div>
      </div>
      <!-- Tarifarios asignados en cards -->
      <div
        class="row mt-2"
        v-if="
          contratoTarifario.tarifarios &&
            contratoTarifario.tarifarios.length > 0
        "
      >
        <div class="col-md-12">
          <div class="card-body p-0">
            <!-- Tarifarios en cards -->
            <div class="row">
              <div
                class="col-lg-6 col-xl-4 mb-4"
                v-for="(tarifario, index) in contratoTarifario.tarifarios"
                :key="index"
              >
                <div class="card h-100 border shadow-sm tarifario-card">
                  <div class="card-header bg-light">
                    <div class="row align-items-center">
                      <div class="col-8">
                        <h6 class="mb-0 text-primary">
                          <i class="fas fa-file-alt mr-1"></i>
                          {{ tarifario.nombre }}
                        </h6>
                        <small class="text-muted"
                          >Contrato #{{ contratoTarifario.no_contrato }}</small
                        >
                      </div>
                      <div class="col-4 text-right">
                        <span
                          class="badge badge-sm"
                          :class="[
                            tarifario.aprobacion_tarifario
                              ? 'bg-gradient-warning'
                              : 'bg-gradient-success',
                          ]"
                        >
                          {{
                            tarifario.estado == 1 ? "Pendiente" : "Definitivo"
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <!-- Vigencia del Contrato -->
                    <div class="float-left">
                      <h6 class="text-muted mb-1">
                        <i class="fas fa-calendar-alt mr-1"></i>
                        Vigencia Contrato
                      </h6>
                      <span class="badge badge-info">
                        {{ contratoTarifario.fecha_ini }} -
                        {{ contratoTarifario.fecha_fin }}
                      </span>
                    </div>

                    <!-- Vigencia del Tarifario -->
                    <div class="float-right">
                      <h6 class="text-muted mb-1">
                        <i class="fas fa-calendar-check mr-1"></i>
                        Cantidad de Tarifas
                      </h6>
                      <span class="badge badge-primary">
                        {{ tarifario.tarifas.length }}
                      </span>
                    </div>

                    <!-- Estado de Aprobación -->
                    <!-- <div class="mb-3">
                       <h6 class="text-muted mb-1">
                         <i class="fas fa-signature mr-1"></i>
                         Estado Aprobación
                       </h6>
                       <div class="d-flex align-items-center">
                <span
                           class="badge badge-sm mr-2"
                           :class="[
                             tarifario.aprobacion_tarifario
                      ? 'badge-success'
                      : 'badge-danger',
                  ]"
                >
                           {{ tarifario.aprobacion_tarifario ? "Aprobado" : "Sin Aprobar" }}
                </span>
                         <small class="text-muted">
                           {{ tarifario.aprobacion_tarifario ? "Transportadora" : "Pendiente" }}
                         </small>
                       </div>
                     </div> -->
                  </div>
                  <div class="card-footer bg-light">
                    <div class="btn-group w-100" role="group">
                      <!-- Subir Documento -->
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        data-toggle="modal"
                        data-target="#modal-form-adjunto-trifario"
                        v-if="
                          !tarifario.pivot.link_documento &&
                            $store.getters.can(
                              'hidrocarburos.contratos.saveDocumentoTarifario'
                            )
                        "
                        @click="instancia(tarifario.id)"
                        title="Subir documento"
                      >
                        <i class="fas fa-upload"></i>
                      </button>

                      <!-- Descargar Documento -->
                      <a
                        target="_blank"
                        class="btn btn-outline-info btn-sm"
                        v-if="tarifario.pivot.link_documento"
                        :href="uri_docs + tarifario.pivot.link_documento"
                        title="Descargar documento"
                      >
                        <i class="fas fa-download"></i>
                      </a>

                      <!-- Firmar -->
                      <!-- <button
                    type="button"
                         class="btn btn-outline-success btn-sm"
                    data-toggle="modal"
                    data-target="#modal-form-firmas"
                         :disabled="!tarifario.pivot.link_documento"X                   
                         title="Firmar tarifario"
                       >
                         <i class="fas fa-signature"></i>
                       </button> -->

                      <!-- Ver Tarifas -->
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="toggleTarifas(tarifario.id)"
                        title="Ver tarifas en esta página"
                      >
                        <i
                          class="fas"
                          :class="
                            tarifario.showTarifas
                              ? 'fa-chevron-up'
                              : 'fa-chevron-down'
                          "
                        ></i>
                        <span class="ml-1">{{
                          tarifario.showTarifas ? "Ocultar" : "Ver"
                        }}</span>
                      </button>

                      <!-- Recordatorio -->
                      <!-- <button
                         type="button"
                         class="btn btn-outline-warning btn-sm"
                         @click="recordarFrima(tarifario)"
                         title="Enviar recordatorio"
                  >
                    <i class="fas fa-envelope"></i>
                       </button> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Sección expandible de tarifas -->
            <div
              class="row"
              v-if="
                contratoTarifario.tarifarios &&
                  contratoTarifario.tarifarios.length
              "
            >
              <div class="col-12">
                <div
                  v-for="(tarifario, index) in contratoTarifario.tarifarios"
                  :key="'tarifas-' + index"
                  class="tarifas-expandible"
                  :class="{ expanded: tarifario.showTarifas }"
                >
                  <div class="card border">
                    <div
                      class="card-header bg-geogo-top-left text-white pt-2 pb-2"
                    >
                      <div class="d-flex align-items-center">
                        <div class="bg-white rounded-circle p-2">
                          <i class="fas fa-calculator text-primary"></i>
                        </div>
                        <div class="flex-grow-1 ml-2">
                          <h5 class="mb-0">{{ tarifario.nombre }}</h5>
                          <small class="text-light"
                            >{{ tarifario.tarifas.length }} tarifa(s)
                            configurada(s)</small
                          >
                        </div>
                        <div class="text-center">
                          <div class="bg-white bg-opacity-25 rounded p-2 pt-2">
                            <span class="h5 d-block mb-0">{{
                              tarifario.tarifas.length
                            }}</span>
                            <small class="text-uppercase">Total</small>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="card-body p-4">
                      <!-- Controles de búsqueda -->
                      <div class="row mb-4">
                        <div class="col-md-8">
                          <div class="input-group">
                            <span class="input-group-text">
                              <i class="fas fa-search"></i>
                            </span>
                            <input
                              type="text"
                              v-model="tarifario.searchTerm"
                              placeholder="Buscar tarifas..."
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="col-md-4 mt-2">
                          <div class="text-end">
                            <span class="badge bg-light border border-dark">
                              Mostrando
                              {{ getPaginatedTarifas(tarifario).length }} de
                              {{ getFilteredTarifas(tarifario).length }}
                              tarifas
                            </span>
                          </div>
                        </div>
                      </div>
                      <!-- Grid de tarifas -->
                      <div class="row g-3">
                        <div
                          v-for="(tarifa, tarifaIndex) in getPaginatedTarifas(
                            tarifario
                          )"
                          :key="tarifaIndex"
                          class="col-lg-6 col-xl-4"
                        >
                          <div class="card h-100 border shadow-sm">
                            <div class="card-header bg-light">
                              <div class="d-flex align-items-center">
                                <div class="bg-info rounded p-2 me-3">
                                  <i class="fas fa-tag text-white"></i>
                                </div>
                                <div class="flex-grow-1 ml-2">
                                  <p class="mb-0">{{ tarifa.nombre }}</p>
                                  <small class="text-muted">
                                    {{ tarifa.nOperacion || "N/A" }}
                                  </small>
                                </div>
                                <div class="text-end">
                                  <span class="text-success mb-0">
                                    {{
                                      formatCurrency(
                                        "es-CO",
                                        "COP",
                                        2,
                                        tarifa.detalle_tarifa?.valor_tarifa || 0
                                      )
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div class="card-body">
                              <div class="row g-2 border border-dark rounded">
                                <div class="col-12 bg-light rounded">
                                  <div
                                    class="d-flex align-items-center p-2 justify-content-center"
                                  >
                                    <i
                                      class="fas fa-calendar-alt text-primary"
                                    ></i>
                                    <small class="text-muted ml-1"
                                      >Vigencia:</small
                                    >
                                    <small class="ml-1">
                                      {{
                                        tarifa.detalle_tarifa
                                          ?.fecha_inicio_vigencia || "N/A"
                                      }}
                                      -
                                      {{
                                        tarifa.detalle_tarifa
                                          ?.fecha_fin_vigencia || "N/A"
                                      }}
                                    </small>
                                  </div>
                                </div>
                                <div class="col-6 bg-light">
                                  <div class="d-flex align-items-center p-2">
                                    <i class="fas fa-truck text-info"></i>
                                    <small class="text-muted d-block ml-1">
                                      Vehículo
                                    </small>
                                    <small class="ml-1">
                                      {{
                                        tarifa.tipo_vehiculo?.nombre || "N/A"
                                      }}
                                    </small>
                                  </div>
                                </div>
                                <div class="col-6 bg-light">
                                  <div class="d-flex align-items-center p-2">
                                    <i class="fas fa-cube text-warning"></i>
                                    <small class="text-muted d-block ml-1">
                                      Bloque
                                    </small>
                                    <small class="ml-1">
                                      {{ tarifa.bloque?.nombre || "N/A" }}
                                    </small>
                                  </div>
                                </div>
                                <div class="col-6 bg-light">
                                  <div class="d-flex align-items-center p-2">
                                    <i
                                      class="fas fa-map-marker-alt text-danger"
                                    ></i>
                                    <small class="text-muted d-block ml-1">
                                      Destino
                                    </small>
                                    <small class="ml-1">
                                      {{
                                        tarifa.sitio_destino?.nombre || "N/A"
                                      }}
                                    </small>
                                  </div>
                                </div>
                                <div class="col-6 bg-light">
                                  <div class="d-flex align-items-center p-2">
                                    <i
                                      class="fas fa-tint text-success me-2"
                                    ></i>
                                    <small class="text-muted d-block ml-1"
                                      >Producto</small
                                    >
                                    <small class="ml-1">{{
                                      tarifa.producto_liquido?.nombre || "N/A"
                                    }}</small>
                                  </div>
                                </div>
                                <div class="col-12 bg-light rounded">
                                  <div
                                    class="d-flex align-items-center p-2 justify-content-center"
                                  >
                                    <span
                                      class="badge"
                                      :class="getStatusClass(tarifa)"
                                    >
                                      <i class="fas fa-circle me-1"></i>
                                      {{ getStatusText(tarifa) }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Paginación -->
                      <div                        
                        class="d-flex justify-content-between align-items-center mt-4"
                      >
                        <div class="d-flex align-items-center">
                          <button
                            class="btn btn-outline-primary btn-sm me-2"
                            :disabled="tarifario.currentPage === 1"
                            @click="
                              changePage(tarifario, tarifario.currentPage - 1)
                            "
                          >
                            <i class="fas fa-chevron-left"></i>
                          </button>

                          <div class="btn-group me-2">
                            <button
                              v-for="page in getVisiblePages(tarifario)"
                              :key="page"
                              class="btn btn-sm"
                              :class="
                                page === tarifario.currentPage
                                  ? 'btn-primary'
                                  : 'btn-outline-primary'
                              "
                              @click="changePage(tarifario, page)"
                            >
                              {{ page }}
                            </button>
                          </div>

                          <button
                            class="btn btn-outline-primary btn-sm"
                            :disabled="
                              tarifario.currentPage === getTotalPages(tarifario)
                            "
                            @click="
                              changePage(tarifario, tarifario.currentPage + 1)
                            "
                          >
                            <i class="fas fa-chevron-right"></i>
                          </button>
                        </div>

                        <div class="d-flex align-items-center">
                          <label class="m-2">Mostrar:</label>
                          <select
                            v-model="tarifario.itemsPerPage"
                            @change="resetPagination(tarifario)"
                            class="form-select form-select-sm"
                            style="width: auto;"
                          >
                            <option value="6">6</option>
                            <option value="12">12</option>
                            <option value="24">24</option>
                            <option value="48">48</option>
                          </select>
                        </div>
                      </div>
                      <!-- Estados vacíos -->
                      <div
                        v-if="getFilteredTarifas(tarifario).length === 0"
                        class="text-center py-5"
                      >
                        <i class="fas fa-search fa-3x text-muted mb-3"></i>
                        <h6 class="text-muted">No se encontraron tarifas</h6>
                        <p class="text-muted mb-0">
                          Intenta con otros términos de búsqueda.
                        </p>
                      </div>
                      <!-- Mensaje cuando no hay tarifas configuradas -->
                      <div
                        v-if="tarifario.tarifas.length === 0"
                        class="text-center py-5"
                      >
                        <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
                        <h6 class="text-muted">
                          No hay tarifas configuradas
                        </h6>
                        <p class="text-muted mb-0">
                          Este tarifario no tiene tarifas asociadas.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Mensaje cuando no hay tarifarios -->
      <div class="row" v-else>
        <div class="col-12">
          <div class="card border-0 shadow-sm">
            <div class="card-body text-center py-5">
              <i class="fas fa-clipboard-list fa-4x text-muted mb-3"></i>
              <h5 class="text-muted">No hay tarifarios asignados</h5>
              <p class="text-muted">
                Asigna un tarifario para comenzar a gestionar las tarifas del
                contrato.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal de Adjunto Tarifario  -->
    <div class="modal fade" id="modal-form-adjunto-trifario">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left text-white pt-2 pb-2">
            <h5 class="modal-title">
              <i class="fas fa-upload mr-2"></i>
              Subir Documento del Tarifario
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeModalArchivo"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="alert alert-default-info">
              <i class="fas fa-info-circle mr-2"></i>
              <strong>Información:</strong> Sube el documento del tarifario para
              proceder con la firma.
            </div>
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label
                    for="archivo-adjunto-tarifario"
                    class="font-weight-bold"
                  >
                    <i class="fas fa-file-upload mr-1"></i>Seleccionar Archivo:
                  </label>
                  <div class="custom-file">
                    <input
                      type="file"
                      id="archivo-adjunto-tarifario"
                      class="custom-file-input"
                      accept="image/x-png,image/gif,image/jpeg,application/pdf,"
                      @change="obtenerArchivo"
                    />
                    <label
                      class="custom-file-label"
                      for="archivo-adjunto-tarifario"
                    >
                      {{
                        fileAdjunto
                          ? fileAdjunto.name
                          : "Seleccionar archivo..."
                      }}
                    </label>
                  </div>
                  <small class="form-text text-muted">
                    Formatos permitidos: PDF, PNG, GIF, JPEG (Máximo 1MB)
                  </small>
                </div>
              </div>
              <div class="col-md-12" v-if="fileAdjunto">
                <div class="alert alert-default-success">
                  <i class="fas fa-check-circle mr-2"></i>
                  <strong>Archivo seleccionado:</strong>
                  {{ fileAdjunto.name }}
                  <button
                    type="button"
                    class="btn btn-xs btn-outline-danger float-right"
                    @click="limpiarArchivo"
                  >
                    <i class="fas fa-times mr-1"></i>
                    Quitar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              <i class="fas fa-times mr-1"></i>
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              v-if="fileAdjunto"
              @click="saveArchivo()"
            >
              <i class="fas fa-save mr-1"></i>
              Guardar Archivo
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Aprobación de tarifarios  -->
    <!-- <div class="modal fade" id="modal-form-firmas">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-success text-white">
            <h5 class="modal-title">
              <i class="fas fa-signature mr-2"></i>
              Aprobación de Tarifario
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card border-0 shadow-sm">
              <div class="card-header bg-light">
                <h6 class="mb-0">
                  <i class="fas fa-truck mr-2 text-primary"></i>
                  Firma Transportadora
                </h6>
              </div>
              <div class="card-body">
                <div
                  v-if="
                    !firmas.transportadoraFlag.firmado &&
                      firmas.transportadoraFlag.permiso
                  "
                >
                  <div class="alert alert-warning">
                    <i class="fas fa-exclamation-triangle mr-2"></i>
                    <strong>Importante:</strong> Para firmar el tarifario,
                    digite su contraseña y observaciones.
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="sign_password" class="font-weight-bold">
                          <i class="fas fa-lock mr-1"></i>Contraseña:
                        </label>
                        <input
                          type="password"
                          class="form-control"
                          id="sign_password"
                          v-model="firmas.transportadoraForm.pass"
                          :class="
                            $v.firmas.transportadoraForm.pass.$invalid
                              ? 'is-invalid'
                              : 'is-valid'
                          "
                          placeholder="Ingrese su contraseña"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="$v.firmas.transportadoraForm.pass.$invalid"
                        >
                          La contraseña es requerida
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="re_sign_password" class="font-weight-bold">
                          <i class="fas fa-lock mr-1"></i>Confirmar Contraseña:
                        </label>
                        <input
                          type="password"
                          class="form-control"
                          id="re_sign_password"
                          v-model="firmas.transportadoraForm.re_pass"
                          :class="
                            $v.firmas.transportadoraForm.re_pass.$invalid
                              ? 'is-invalid'
                              : 'is-valid'
                          "
                          placeholder="Confirme su contraseña"
                        />
                        <div
                          class="invalid-feedback"
                          v-if="$v.firmas.transportadoraForm.re_pass.$invalid"
                        >
                          Las contraseñas deben coincidir
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group">
                        <label for="observaciones" class="font-weight-bold">
                          <i class="fas fa-comment mr-1"></i>Observaciones:
                        </label>
                        <textarea
                          class="form-control"
                          id="observaciones"
                          rows="3"
                          v-model="firmas.transportadoraForm.observacion"
                          :class="
                            $v.firmas.transportadoraForm.observacion.$invalid
                              ? 'is-invalid'
                              : 'is-valid'
                          "
                          placeholder="Ingrese observaciones sobre la aprobación..."
                        ></textarea>
                        <div
                          class="invalid-feedback"
                          v-if="
                            $v.firmas.transportadoraForm.observacion.$invalid
                          "
                        >
                          Las observaciones son requeridas
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-else-if="firmas.transportadoraFlag.firmado">
                  <div class="alert alert-success">
                    <i class="fas fa-check-circle mr-2"></i>
                    <strong>Tarifario ya aprobado</strong>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="text-center p-3 border rounded">
                        <i class="fas fa-user fa-2x text-primary mb-2"></i>
                        <h6 class="text-muted mb-1">Firmado por</h6>
                        <strong>{{
                          firmas.transportadoraFlag.data.usuario
                        }}</strong>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="text-center p-3 border rounded">
                        <i class="fas fa-calendar fa-2x text-success mb-2"></i>
                        <h6 class="text-muted mb-1">Fecha</h6>
                        <strong>{{
                          firmas.transportadoraFlag.data.fecha
                        }}</strong>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="text-center p-3 border rounded">
                        <i class="fas fa-comment fa-2x text-info mb-2"></i>
                        <h6 class="text-muted mb-1">Observación</h6>
                        <small>{{
                          firmas.transportadoraFlag.data.observacion ||
                            "Sin observaciones"
                        }}</small>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-else>
                  <div class="alert alert-danger">
                    <i class="fas fa-ban mr-2"></i>
                    <strong>Sin permisos:</strong> No tienes permisos para
                    firmar este tarifario.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="modal-footer"
            v-if="
              !firmas.transportadoraFlag.firmado &&
                firmas.transportadoraFlag.permiso
            "
          >
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              <i class="fas fa-times mr-1"></i>
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-success"
              v-if="!$v.firmas.transportadoraForm.$invalid"
              @click="saveFirma(firmas.transportadoraForm)"
            >
              <i class="fas fa-signature mr-1"></i>
              Aprobar Tarifario
            </button>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import { required, sameAs } from "vuelidate/lib/validators";

export default {
  name: "ContratoTarifario",
  components: {
    vSelect,
  },
  data() {
    return {
      contrato_id: null,
      tarifario: {},
      contratoTarifario: {},
      fileAdjunto: null,
      archivoValido: true,
      firmas: {
        transportadoraForm: {
          tipo_aprobacion: "transportadora",
          contrato_id: null,
          tarifario_id: null,
          contrato_has_tarifario_id: null,
          observacion: null,
          pass: null,
          re_pass: null,
        },
      },
      form: {
        tarifario_id: null,
        contrato_id: null,
      },
      uri_docs: process.env.VUE_APP_AWS_BUCKET_URL,
      listasForms: {
        tarifarios: [],
      },
    };
  },
  validations: {
    form: {
      tarifario_id: {
        required,
      },
    },
    firmas: {
      transportadoraForm: {
        pass: {
          required,
        },
        re_pass: {
          required,
          sameAsPassword: sameAs("pass"),
        },
        observacion: {
          required,
        },
      },
    },
  },
  methods: {
    init(contratoTarifario) {
      this.contratoTarifario = contratoTarifario;
      this.getTarifariosLista();
    },

    formatCurrency(locales, currency, fractionDigits, number) {
      var formato = new Intl.NumberFormat(locales, {
        style: "currency",
        currency: currency,
        minimumFractionDigits: fractionDigits,
      }).format(number);

      return formato;
    },

    getTarifariosLista() {
      axios
        .get("/api/hidrocarburos/tarifarios/lista", {
          params: {
            empresa_id: this.$parent.form.empresa_id,
            estado: 2,
          },
        })
        .then((response) => {
          let respuesta = response.data;
          for (let index = 0; index < respuesta.length; index++) {
            respuesta[index].nombre_completo =
              respuesta[index].id +
              " - " +
              respuesta[index].nombre +
              " - " +
              respuesta[index].empresa.razon_social;
          }
          this.listasForms.tarifarios = response.data;
        });
    },

    selectTarifario() {
      this.form.tarifario_id = null;
      this.form.contrato_id = this.contratoTarifario.id;
      if (this.tarifario) {
        this.form.tarifario_id = this.tarifario.id;
      }
    },

    saveTarifario() {
      if (!this.$v.form.$invalid) {
        this.$parent.cargando = true;
        axios({
          method: "POST",
          url: "/api/hidrocarburos/contratos/asignarTarifario",
          data: this.form,
        })
          .then((response) => {
            this.$parent.cargando = false;
            this.$parent.init();
            this.form.tarifario_id = null;
            this.tarifario = {};
            this.$swal({
              icon: "success",
              title: "Se asignó el tarifario exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          })
          .catch((e) => {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            this.$parent.cargando = false;
          });
      }
    },

    toggleTarifas(tarifarioId) {
      const tarifario = this.contratoTarifario.tarifarios.find(
        (t) => t.id === tarifarioId
      );
      if (tarifario) {
        this.$set(tarifario, "showTarifas", !tarifario.showTarifas);

        // Inicializar propiedades de paginación si no existen
        if (!tarifario.currentPage) {
          this.$set(tarifario, "currentPage", 1);
        }
        if (!tarifario.itemsPerPage) {
          this.$set(tarifario, "itemsPerPage", 12);
        }
        if (!tarifario.searchTerm) {
          this.$set(tarifario, "searchTerm", "");
        }
      }
    },

    getFilteredTarifas(tarifario) {
      if (!tarifario.searchTerm) {
        return tarifario.tarifas || [];
      }

      const searchTerm = tarifario.searchTerm.toLowerCase();
      return (tarifario.tarifas || []).filter(
        (tarifa) =>
          tarifa.nombre.toLowerCase().includes(searchTerm) ||
          (tarifa.tipo_vehiculo?.nombre || "")
            .toLowerCase()
            .includes(searchTerm) ||
          (tarifa.bloque?.nombre || "").toLowerCase().includes(searchTerm) ||
          (tarifa.sitio_destino?.nombre || "")
            .toLowerCase()
            .includes(searchTerm) ||
          (tarifa.producto_liquido?.nombre || "")
            .toLowerCase()
            .includes(searchTerm) ||
          (tarifa.nOperacion || "").toLowerCase().includes(searchTerm)
      );
    },

    getPaginatedTarifas(tarifario) {
      const filteredTarifas = this.getFilteredTarifas(tarifario);
      const startIndex = (tarifario.currentPage - 1) * tarifario.itemsPerPage;
      const endIndex = startIndex + tarifario.itemsPerPage;
      return filteredTarifas.slice(startIndex, endIndex);
    },

    getTotalPages(tarifario) {
      const filteredTarifas = this.getFilteredTarifas(tarifario);
      return Math.ceil(filteredTarifas.length / tarifario.itemsPerPage);
    },

    getVisiblePages(tarifario) {
      const totalPages = this.getTotalPages(tarifario);
      const currentPage = tarifario.currentPage;
      const visiblePages = [];

      // Mostrar máximo 5 páginas
      let startPage = Math.max(1, currentPage - 2);
      let endPage = Math.min(totalPages, startPage + 4);

      // Ajustar si estamos cerca del final
      if (endPage - startPage < 4) {
        startPage = Math.max(1, endPage - 4);
      }

      for (let i = startPage; i <= endPage; i++) {
        visiblePages.push(i);
      }

      return visiblePages;
    },

    changePage(tarifario, page) {
      const totalPages = this.getTotalPages(tarifario);
      if (page >= 1 && page <= totalPages) {
        this.$set(tarifario, "currentPage", page);
      }
    },

    resetPagination(tarifario) {
      this.$set(tarifario, "currentPage", 1);
    },

    getStatusClass(tarifa) {
      // Lógica para determinar la clase del estado usando Bootstrap
      const fechaFin = new Date(tarifa.detalle_tarifa?.fecha_fin_vigencia);
      const hoy = new Date();

      if (fechaFin < hoy) {
        return "bg-danger";
      } else if (
        fechaFin.getTime() - hoy.getTime() <
        30 * 24 * 60 * 60 * 1000
      ) {
        // 30 días
        return "bg-warning text-dark";
      } else {
        return "bg-success";
      }
    },

    getStatusText(tarifa) {
      const fechaFin = new Date(tarifa.detalle_tarifa?.fecha_fin_vigencia);
      const hoy = new Date();

      if (fechaFin < hoy) {
        return "Vencida";
      } else if (
        fechaFin.getTime() - hoy.getTime() <
        30 * 24 * 60 * 60 * 1000
      ) {
        return "Por Vencer";
      } else {
        return "Activa";
      }
    },

    instancia(tarifario_id) {
      this.tarifario_id = tarifario_id;
    },

    limpiarArchivo() {
      this.fileAdjunto = null;
      document.getElementById("archivo-adjunto-tarifario").value = "";
    },

    obtenerArchivo(e) {
      this.fileAdjunto = null;
      this.archivoValido = false;
      if (e.target.files[0]) {
        this.cargando = true;
        const file = e.target.files[0];
        if (this.validaArchivo(file)) {
          this.archivoValido = true;
          this.fileAdjunto = file;
        }
      } else {
        this.archivoValido = true;
      }
    },

    validaArchivo(file) {
      let flag = true;
      if (file.size > 1000000) {
        flag = false;
        this.limpiarArchivo();
        this.$swal({
          icon: "error",
          title: `El Archivo es muy pesado para subirlo, seleccione un archivo de nuevo...`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
      return flag;
    },

    saveArchivo() {
      this.cargando = true;
      let me = this;
      let formData = new FormData();
      formData.append("contrato_id", this.contratoTarifario.id);
      formData.append("tarifario_id", this.tarifario_id);
      formData.append("link_documento", this.fileAdjunto);
      axios
        .post("/api/hidrocarburos/contratos/asignarTarifario", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.$parent.init();
          this.$refs.closeModalArchivo.click();
          this.limpiarArchivo();
          this.$swal({
            icon: "success",
            title: "El archivo se guardó exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.archivoValido = false;
          (this.fileAdjunto = null),
            (this.link_documento = response.data.link_documento);
          this.cargando = false;
        })
        .catch(function(error) {
          me.$swal({
            icon: "error",
            title: "Ocurrió un error" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    saveFirma(array) {
      let me = this;
      if (!this.$v.firmas.transportadoraForm.$invalid) {
        let pass = array.pass;
        let data = {
          contrato_id: array.contrato_id,
          tarifario_id: array.tarifario_id,
          contrato_has_tarifario_id: array.contrato_has_tarifario_id,
          observacion: array.observacion,
          tipo_aprobacion: array.tipo_aprobacion,
          user_id: this.$store.getters.getUser.id,
        };
        let form = { data, pass };

        // Se valida la url para hacer la firma
        let url = null;
        switch (array.tipo_aprobacion) {
          case "transportadora":
            url = "/api/hidrocarburos/tarifariocontratos/firmaTransportadora";
            break;
        }

        axios({
          method: "PUT",
          url,
          data: form,
        })
          .then((response) => {
            me.$parent.form.estado = response.data.estado_contrato;
            me.$parent.estado = response.data.estado_contrato;
            me.resetForm();
            me.getIndex();
            me.$swal({
              icon: "success",
              title: "La tarifa fue autorizada exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });

            const mensaje_correo = response.data.envio_correo;
            if (mensaje_correo.msg) {
              me.$swal({
                icon: "success",
                title: mensaje_correo.msg,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (mensaje_correo.error) {
              me.$swal({
                icon: "error",
                title: "Ocurrió un error: " + mensaje_correo.error,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            }
          })
          .catch((e) => {
            me.$swal({
              icon: "error",
              title: "Ocurrió un error: " + e.response.data.msg,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    resetForm() {
      this.firmas = {
        transportadoraForm: {
          tipo_aprobacion: "transportadora",
          observacion: null,
          pass: null,
          re_pass: null,
        },
      };
    },

    recordarFrima(tarifario) {
      this.$swal({
        title: "Esta seguro de enviar este Recordatorio?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Enviar!",
      }).then((result) => {
        if (result.value) {
          let me = this;
          const data = {
            contrato_id: tarifario.contrato_id,
            tarifario_id: tarifario.tarifario_id,
          };

          axios
            .post("/api/hidrocarburos/tarifarios/emailRecordarorioFirma", {
              data: data,
            })
            .then((response) => {
              const mensaje_correo = response.data;
              if (mensaje_correo.msg) {
                me.$swal({
                  icon: "success",
                  title: mensaje_correo.msg,
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                });
              }
              if (mensaje_correo.error) {
                me.$swal({
                  icon: "error",
                  title: "Ocurrió un error: " + mensaje_correo.error,
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                });
              }
            })
            .catch(function(error) {
              me.$swal({
                icon: "error",
                title: "Ocurrió un error" + error,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      });
    },
  },
};
</script>

<style>
/* Animación para la sección expandible */
.tarifas-expandible {
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  transition: all 0.5s ease;
}

.tarifas-expandible.expanded {
  opacity: 1;
  max-height: 100%;
}

/* Hover effects para las cards */
.tarifario-card {
  transition: all 0.3s ease;
}

.tarifario-card:hover {
  transform: translateY(-5px);
}

/* Estilos para los modales */
.modal-xl {
  max-width: 95%;
}

/* Animaciones suaves */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
